import Swiper from 'swiper/bundle';
import { Datepicker } from 'vanillajs-datepicker';
import '../../../node_modules/vanillajs-datepicker/dist/css/datepicker.min.css';



export const swiperStffSlider = (element) => {
    let swiperStaff = new Swiper(element, {
        //spaceBetween: 15,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function() {
                updateSlideStates(this);
                updateBookNowButton(this);
            },
            slideChange: function() {
                updateSlideStates(this);
                updateBookNowButton(this);
            }
        }
    });

    function updateSlideStates(swiper) {
        swiper.slides.forEach((slide, index) => {
            if (index === swiper.activeIndex) {
                slide.classList.add('swiper-slide-active-center');
                slide.classList.remove('swiper-slide-inactive');
            } else {
                slide.classList.remove('swiper-slide-active-center');
                slide.classList.add('swiper-slide-inactive');
            }
        });
    }

    function updateBookNowButton(swiper) {
        const bookNowBtn = document.getElementById('bookNowBtn');
        if (bookNowBtn) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            const profileLink = activeSlide?.querySelector('.card-memberStaff-overview');
            
            if (profileLink) {
                const bookingUrl = profileLink.getAttribute('data-booking');
                bookNowBtn.onclick = function() {
                    window.location.href = bookingUrl;
                };
            }
        }
    }

    return swiperStaff;
}

export const swiperBookingSlider = (element) => {
    let swiperStaffBooking = new Swiper(element, {
        //spaceBetween: 15,
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: "auto",
            }
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true,
            renderBullet: function (index, className) {
                return `<span class="${className}"></span>`;
            },
        },
        on: {
            init: function() {
                setTimeout(() => {
                    const paginationBullets = document.querySelectorAll('.swiper-pagination-bullet');
                    paginationBullets.forEach((bullet, index) => {
                        const slideImg = this.slides[index].querySelector('img').src;
                        bullet.innerHTML = `<img src="${slideImg}" alt="Thumbnail ${index+1}">`;
                    });
                }, 100);

                // Create custom pagination for dashes
                const dashesElement = document.querySelector('.pagination-fraction');
                dashesElement.innerHTML = '';

                for (let i = 0; i < this.slides.length; i++) {
                    const bullet = document.createElement('span');
                    bullet.className = 'swiper-pagination-deshe';
                    bullet.addEventListener('click', () => {
                        this.slideTo(i);
                    });
                    dashesElement.appendChild(bullet);
                }

                // Update active state
                this.updateDashesPagination = function() {
                    const bullets = dashesElement.querySelectorAll('.swiper-pagination-deshe');
                    bullets.forEach((bullet, index) => {
                        if (index === this.activeIndex) {
                            bullet.classList.add('swiper-pagination-deshe-active');
                        } else {
                            bullet.classList.remove('swiper-pagination-deshe-active');
                        }
                    });
                };

                // Initial update
                this.updateDashesPagination();
            },
            slideChange: function() {
                this.updateDashesPagination();
            }
        },
    });
}

export const showDatePicker = (element) => {
    //console.log(typeof element);
    const elem = (typeof element === 'string') ? document.querySelector(element) : element;
    if(elem) {
        const today = new Date();
        const datepicker = new Datepicker(elem, {
            enableOnReadonly: true,
            autohide: false,
            minDate: today,
            format: {
                toValue(dateStr, format, locale) {
                    // Parse back to a Date object (use default)
                    return new Date(dateStr);
                },
                toDisplay(date, format, locale) {
                    // Custom display: "31 Sept, 2025"
                    const options = { day: 'numeric', month: 'short', year: 'numeric' };
                    let formatted = date.toLocaleDateString('en-GB', options);
                    const parts = formatted.split(' ');
                    return `${parts[0]} ${parts[1]}, ${parts[2]}`;
                }
            }
        });
        datepicker?.show();
    }
}

export const bsModals = () => {
    const dateModalEl = document.getElementById('bookingModalDate');
    let dateModal = dateModalEl?bootstrap.Modal.getOrCreateInstance(dateModalEl):null;
    const modalEl = document.getElementById('bookingHourModal');
    let hourModal = modalEl?bootstrap.Modal.getOrCreateInstance(modalEl):null;
    let bookingDate = document.querySelector('.bookingDate');
    let bookingHour = document.querySelector('.durationValue');

    return {dateModal, hourModal, bookingDate, bookingHour};
}

export const showBookingModalDateDuration = (bookingDateEle, bookingHourEle, getBookDateEle, saveDateBtnEle) => {

    // const hourModalEl = document.getElementById('bookingHourModal');
    // let hourModal = hourModalEl?bootstrap.Modal.getOrCreateInstance(hourModalEl):null;

    const {dateModal, hourModal, bookingDate, bookingHour} = bsModals();



    let btnDateSave = document.querySelector(saveDateBtnEle);
    let getBookDateInput = document.querySelector(getBookDateEle);
    //console.log(bookingHour);
    //console.log(bookingDate, bookingHour, btnDateSave, getBookDateInput);
    //dateModal?.show();

    showDatePicker(getBookDateInput);


    btnDateSave?.addEventListener('click', () => {
        const date = getBookDateInput?.value;
        //console.log(date);
        if(date) {
            bookingDate.value = date;
            dateModal?.hide();
            document.querySelector('.dt-modal').innerHTML = 'Change';
            if(bookingHour && bookingHour?.value == "") {
                hourModal?.show();
            }
        }
    });
}

export const updateDuration = (selectDuration, durationValue, saveBtn, saveTimeBtn, bookTime, bookType, outcallAddress, hourInput, minuteInput, ampmInputs, saveAddressBtn) => {
    const select = document.querySelector(selectDuration);
    const input  = document.querySelector(durationValue);
    const btn    = document.querySelector(saveBtn);
    const timeBtn = document.querySelector(saveTimeBtn);
    const inputHour = document.querySelector(hourInput);
    const inputMinute = document.querySelector(minuteInput);
    const inputsAmPm = document.querySelectorAll(ampmInputs);
    const bookTimeInput = document.querySelector(bookTime);
    const bookTypeInputs = document.querySelectorAll(bookType);
    const outcallAddressContainer = document.querySelector(outcallAddress);
    const confirmAddressBtn = document.querySelector(saveAddressBtn);

    const {dateModal, hourModal, bookingDate, bookingHour} = bsModals();
    const timemodalEl = document.getElementById('bookingTimeModal');
    let timeModal = timemodalEl?bootstrap.Modal.getOrCreateInstance(timemodalEl):null;
    const outcallAddressModalEl = document.getElementById('outcallbookingAddressModal');
    let outcallAddressModal = outcallAddressModalEl?bootstrap.Modal.getOrCreateInstance(outcallAddressModalEl):null;

    console.log(bookingDate);

    //console.log(modalEl, hourModal);
    select?.addEventListener('change', () => {
        const value = select.selectedOptions[0].dataset.title;
        console.log(select.selectedOptions[0].dataset.title);
        if (value) {
            bookingHour.setAttribute('value', value); //+ (value === '1' ? ' hour' : ' hours');

        } else {
            bookingHour.setAttribute('value', '');
            document.querySelector('.bk-modal').innerHTML = 'Add';
        }
        //console.log(input.value);
    });

    btn?.addEventListener('click', () => {
        const value = select.value;
        if (value) {
            hourModal?.hide();
            if(bookTimeInput.value == "") {
                timeModal?.show();
            }else if(bookingDate.value == "") {
                dateModal?.show();
            }
            document.querySelector('.bk-modal').innerHTML = 'Change';
        }else{
            document.querySelector('.bk-modal').innerHTML = 'Add';
        }
    });

    bookTypeInputs?.forEach(input => {
        input.addEventListener('change', () => {
            if(input.value == 'outcall') {
                outcallAddressContainer?.classList.remove('d-none');
                outcallAddressModal?.show();
                bookingHour.setAttribute('value', '');
                document.querySelector('.bk-modal').innerHTML = 'Add';
            }else{
                outcallAddressContainer?.classList.add('d-none');
                if(bookingDate.value == '') {
                    dateModal?.show();
                }else{
                    hourModal?.show();
                }
                bookingHour.setAttribute('value', '');
                document.querySelector('.bk-modal').innerHTML = 'Add';
            }
        });
    });

    confirmAddressBtn?.addEventListener('click', () => {
        const address = document.querySelector('.confirm-address')?.value;
        console.log(address);
        if(address) {
            let addressInput = outcallAddressContainer.querySelectorAll('.booking-address');
            addressInput.forEach(input => {
                //console.log(input);
                input.value = address;
            });
            outcallAddressModal?.hide();
            if(bookingDate.value == '') {
                dateModal?.show();
            }else{
                hourModal?.show();
            }
        }
    });



    const getBookTime = () => {
        let hour = '5';
        let minute = '00';

        const updateTime = () => `${hour}:${minute}`;


        inputHour?.addEventListener('blur', () => {
          if(inputHour.value < 13 && inputHour.value > 0) {
            hour = inputHour.value;
          }else{
            hour = '1';
            inputHour.value = '1';
          }
        });


        inputMinute?.addEventListener('blur', () => {
          if(inputMinute.value < 60 && inputMinute.value > -1 && inputMinute.value.length == 2) {
            minute = inputMinute.value;
          }else{
            minute = '00';
            inputMinute.value = '00';
          }
        });

        return updateTime;
    };

    const timeUpdater = getBookTime();

    timeBtn?.addEventListener('click', () => {
        const currentTime = timeUpdater();
        let ampm = '';

        inputsAmPm.forEach(input => {
          if (input.checked) ampm = input.value;
        });

        bookTimeInput.value = `${currentTime}${ampm}`;
        timeModal?.hide();
        document.querySelector('.bt-modal').innerHTML = 'Change';
        if(bookingDate.value == '') {
            dateModal?.show();
        }
    });

}


export const memberMennu = (...args) => {
    const [headerMin, main, footerMain, menuDashboardWrap] = args;    
    let headerMinEl = document.querySelector(headerMin);
    let menuToggleEl = headerMinEl.querySelector('.menuToggle');
    let mainEl = document.querySelector(main);
    let footerMainEl = document.querySelector(footerMain);
    let menuDashboardWrapEl = document.querySelector(menuDashboardWrap);
    let html = document.querySelector('html');
    let body = document.querySelector('body');
    let flag = false;
    //console.log(menuToggleEl, headerMinEl, mainEl, footerMainEl, menuDashboardWrapEl);
    let removeActive = () => {
        headerMinEl?.classList.remove('active');
        mainEl?.classList.remove('active');
        footerMainEl?.classList.remove('active');
        menuDashboardWrapEl?.classList.remove('active');
        html?.classList.remove('overflow-hidden');
        body?.classList.remove('overflow-hidden');
        flag = false;
    };
    menuToggleEl?.addEventListener('click', () => {
        if(! flag) {
            headerMinEl?.classList.add('active');
            mainEl?.classList.add('active');
            footerMainEl?.classList.add('active');
            menuDashboardWrapEl?.classList.add('active');
            html?.classList.add('overflow-hidden');
            body?.classList.add('overflow-hidden');
            flag = true;
        }else{
            removeActive();
        }
    });
    document.addEventListener('click', (e) => {     
        const isClickInsideMenu = menuDashboardWrapEl?.contains(e.target);
        const isClickOnToggle = menuToggleEl?.contains(e.target);   
        if(!isClickInsideMenu && !isClickOnToggle) {
            removeActive();
        }
    });
}